import React from 'react';
import classNames from 'classnames';

import GetMyEstimateForm from '../GetMyEstimateForm';

import styles from './GetPriceHero.module.scss';

import everdaysLogo from '../../public/images/everdays-logo-hero.png';
import navyCheckIcon from '../../public/images/icons/navy-check.svg';

const {
  'get-price-hero': getPriceHeroClass,
  'estimate-form-container': estimateFormContainerClass,
  'mobile-header': mobileHeaderClass,
  'form-title': formTitleClass,
  'hero-image': heroImageClass,
  'hero-logo': heroLogoClass,
  'hero-title-copy': titleCopyClass,
  'hero-subtitle-copy': subtitleCopyClass,
  'hero-image-container': heroImageContainerClass,
  'hero-markup': heroMarkupClass,
  'markup-wrapper': markupWrapper,
  'hero-list': heroListClass,
  price: priceClass
} = styles;

const HeroImage = ({
  currentPage,
  renderMarkup,
  titleCopy = 'Instant pricing for your funeral or cremation',
  subtitleCopy = ''
}) => {
  const heroImageClasses = classNames(heroImageClass, {
    [priceClass]: currentPage === 'getMyPrice'
  });

  return (
    <div className={heroImageContainerClass}>
      <div className={heroImageClasses}>
        <div className={markupWrapper}>
          <a href="/">
            <img className={heroLogoClass} src={everdaysLogo} alt="logo" />
          </a>
          <h1 className={titleCopyClass}>{titleCopy}</h1>
          {subtitleCopy && <h4 className={subtitleCopyClass}>{subtitleCopy}</h4>}
          {!!renderMarkup && <div className={heroMarkupClass}>{renderMarkup}</div>}
        </div>
      </div>
    </div>
  );
};

const GetPriceHero = ({
  preneedPackages,
  isLoggedIn,
  userData,
  currentPage = 'getMyPrice',
  location
}) => {
  const titleCopy = 'Instant pricing for your funeral or cremation';
  const subtitleCopy = '100% online & bundled into one simple purchase';

  const heroMarkup = () => (
    <div className={heroMarkupClass}>
      <ul className={heroListClass}>
        <li>
          <img src={navyCheckIcon} alt="checkmark" />
          <span>100% online</span>
        </li>
        <li>
          <img src={navyCheckIcon} alt="checkmark" />
          <span>Everything bundled</span>
        </li>
        <li>
          <img src={navyCheckIcon} alt="checkmark" />
          <span>Flexible payment options</span>
        </li>
      </ul>
    </div>
  );

  return (
    <div className={getPriceHeroClass}>
      <HeroImage {...{ currentPage, titleCopy, subtitleCopy }} />
      <div className={estimateFormContainerClass}>
        <div className={mobileHeaderClass}>
          <a href="/">
            <img className={heroLogoClass} src={everdaysLogo} alt="logo" />
          </a>
          <h1 className={titleCopyClass}>{titleCopy}</h1>
          <p>100% online &amp; bundled into one simple purchase</p>
        </div>
        <p className={formTitleClass}>get your personal price</p>
        <GetMyEstimateForm
          {...{
            preneedPackages,
            isLoggedIn,
            userData,
            location
          }}
        />
      </div>
    </div>
  );
};

export default GetPriceHero;
